module.exports = __webpack_public_path__ + "static/media/power-atk3.830e036c.png";